"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSearchResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const CreateFolderModal_style_1 = require("./CreateFolderModal.style");
exports.GroupSearchResult = (0, react_1.memo)(function GroupSearchResult({ group, parentGroups, onSelected, }) {
    const theme = (0, styled_components_1.useTheme)();
    const handleClick = (0, react_1.useCallback)((checked) => {
        onSelected(group, checked);
    }, [group, onSelected]);
    const isDisable = (0, react_1.useMemo)(() => {
        if (!parentGroups || parentGroups.length === 0)
            return false;
        return !parentGroups.find((parentGroup) => parentGroup.id === group.id);
    }, [group, parentGroups]);
    const isChecked = (0, react_1.useMemo)(() => {
        if (!parentGroups)
            return false;
        return parentGroups.some((parentGroup) => parentGroup.id === group.id);
    }, [group, parentGroups]);
    return ((0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledSearchResult, { "aria-disabled": "true", children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Checkbox, { onClick: handleClick, disabled: isDisable, checked: isChecked }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "BodyLarge", color: isDisable ? theme.Color.Neutrals.Gray : theme.Color.Neutrals.Dark, children: group.name })] }));
});
//# sourceMappingURL=GroupSearchResult.js.map